import { getFieldValue } from "@digitallab/grid-common-frontend-components";

const LinkedInstanceRender = (params) => {
  return <>{getFieldValue(params?.data, "linked_instance")}</>;
};

export default LinkedInstanceRender;
